var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"badge badge-warning entry_force"},[_vm._v(" 社内登録モード ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }